type StaleCheck = () => boolean

export const createRequestGuard = () => {
  let version = 0

  return {
    begin: (isInvalidated?: StaleCheck): StaleCheck => {
      const requestVersion = ++version

      return () => requestVersion !== version || Boolean(isInvalidated?.())
    },
    invalidate: () => {
      version += 1
    },
  }
}
